<template>
    <div>
        <!-- Modal -->
        <v-dialog v-model="modal.show" persistent max-width="550px" tabindex="-2">
            <v-card class="modal--tips4y simple-revision">
                <v-card-title class="headline d-flex justify-center">
                    <h2 class="mb-0">{{ $t('module-budget.simple-revision.title') }}</h2>
                    <div class="icon-close" v-if="!catchMsg">
                        <div name="modal-close" >
                            <div @click="onCancelClicked(false)">
                                <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                            </div>
                        </div>
                    </div>
                </v-card-title>

                <div class="padding-div">
                    <p style="color: '#4b4849'; font-size: 13px; opacity: 1" v-show="modal.iconName === null">{{ $t('module-budget.simple-revision.subtitle') }}</p>
                    <div
                        v-show="operationsToShow !== ''"
                        class="operations-list"
                        :style="$vuetify.breakpoint.xsOnly ? '' : 'margin-left: 80px; margin-right: 80px'"
                    >
                        <div v-for="(item, index) in operationsToShow" :key="index">
                            <span @click="clickboxCheckManagement('maintenance', item)">
                                <CheckBox :config="mixinCheckboxValue('maintenance', item)" :disabled="false" :data-cy="`checkbox-simple-revision-${index}`"></CheckBox>
                            </span>
                        </div>
                    </div>
                    <div :style="$vuetify.breakpoint.xsOnly ? '' : 'margin-left: 94px; margin-right: 94px;'" v-show="modal.iconName === null">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-form ref="simple_revision_form" v-model="validateForm">
                                  <v-text-field @keypress="onlyNumberRule2" :bind="attrs" v-on="on" class="mt-4" v-model="kilometers" name="Kms" :label="`${$t('module-budget.simple-revision.km')}*`" :rules="kmRules" required filled data-cy= 'kms-simple-revision'></v-text-field>
                                </v-form>
                            </template>
                            <span>{{$t('module-budget.simple-revision.insert-km')}}</span>
                        </v-tooltip>
                    </div>

                    <div v-show="operationsToShow === ''">
                        {{ modal.message }}
                    </div>

                    <template v-if="modal.iconColor && modal.iconName">
                        <v-icon style="font-size: 5rem;" class="d-block text-center remove-pseudo-after" :color="modal.iconColor">
                            {{modal.iconName}}
                        </v-icon>
                    </template>
                </div>

                <v-card-actions class="align__flex--center">
                    <v-btn v-if="!catchMsg" class="danger-button" text @click="onCancelClicked(false)" style="text-transform: capitalize" data-cy="cancel-button-simple-revision">
                        {{$t('cancel')}}
                    </v-btn>
                    <v-btn v-if="!catchMsg" :disabled="checkItems" class="primary-button" text @click="onBudgetClicked" style="text-transform: capitalize" data-cy="budget-button-simple-revision">
                        {{$t('module-budget.simple-revision.budget')}}
                    </v-btn>
                    <v-btn v-if="catchMsg" class="primary-button" text @click="onCancelClicked(false)" style="text-transform: capitalize">
                        {{$t('ok')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Modal -->
    </div>
</template>

<script>
import {
    BudgetServicePostOperationsFromItemMpIdAndKorId,
    BudgetServiceGetSimpleRevisionOperations
} from '@services/b2b/quotation/QuotationServices';
import CheckBox from '@components/b2b/widgets/CheckBoxComponent';
import mixinCheckbox from '@mixins/b2b/budget/checkboxValue.js';

const kmLimit = 999999;

export default {
    components: { CheckBox },

    mixins: [mixinCheckbox],

    data() {
        return {
            modal: {
                show: true,
                message: this.$t('module-budget.simple-revision.loading'),
                iconColor: null,
                iconName: null
            },

            kilometers: '',
            kmRules2: [
                v => !!v || this.$t('module-budget.simple-revision.kmRules1')
            ],
            kmRules: [
                v => !!v || this.$t('module-budget.simple-revision.kmRules1'),
                v => (v && v < kmLimit) || this.$t('module-budget.simple-revision.kmRules2') + kmLimit
            ],

            checkBoxOperations: '',
            operationsToShow: '',
            step1: {
                fields: {
                    Kilometers: null
                }
            },

            validateForm: false,

            catchMsg: false
        };
    },

    watch: {
        modal: {
            handler: function(newValue, oldValue) {
                if(newValue.show) {
                    const checkCurrentStep = this.$store.getters['budget/getB2bCurrentStep'];
                    if(checkCurrentStep === 3) {
                        this.onCancelClicked(true);
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },

    computed: {
        checkItems() {
            let shoppingCart = this.$store.getters['budget/getB2bCurrentShoppingCart'].operations.maintenance.length;
            return !(this.kilometers && shoppingCart !== 0 && this.validateForm);
        },

        clickedItems() {
            return this.$store.getters['budget/getB2bCurrentShoppingCart'].operations.maintenance.map(el => el ?
                { id: el.itemMpId, qualColId: el.qualColId } : {}
            );
        }
    },

    methods: {
        async onCancelClicked(justClearCart) {
            this.catchMsg = false;
            // Clear Budget and Shopping Cart
            if(!justClearCart) {
                this.modal.show = false;

                this.modal.iconColor = null;
                this.modal.iconName = null;
            }
            let processNummber = this.$store.getters['vehicleIdentification/getState'].processNumber;
            this.$store.commit('budget/setB2bClearShoppingCart');
            this.$store.commit('budget/setB2bCurrentStep', 1);
            const payloadBudgetStartedBy = {
                budgetId: null,
                budgetName: ''
            }
            this.$store.commit('budget/setBudgetStartedBy', payloadBudgetStartedBy);
            localStorage.removeItem('budgetB2b');
            /*if (this.$route.name !== 'dashboard') {
                this.$router.push({ name: 'dashboard' });
            }*/
            await this.$nextTick();
            const shoppingCartCopy = {
                operations: [],
                parts: [],
            }
            this.$store.commit('budget/setShoppingCartCopy', shoppingCartCopy);
            localStorage.removeItem('@copyShoppingCart');
            this.$store.commit('budget/setCurrentProcessNumberByCar', processNummber);
            this.$store.commit('budget/setClearBudgetSummary', {});
             if(!justClearCart) {
                 this.$emit('closeModalSimples', false);
             }
        },

        onBudgetClicked() {
            this.modal.show = false;
            this.postOperationsFromItemMpIdAndKorId();
            this.storageBudgetStartedBy();
            this.step1.fields.Kilometers =  this.kilometers

            this.$store.commit('budget/setB2b', {
                step1: { fields: this.step1.fields }
            });

            this.$store.commit('budget/setB2bCurrentStep', 3);
        },

        clickboxCheckManagement(type, item) {
            let payload = {
                item: item,
                type: type
            };

            this.$store.commit('budget/setB2bRemoveOrAddShoppingCartItem', payload);
        },

        postOperationsFromItemMpIdAndKorId() {
            this.$store.commit('loadings/setStateLoadingTemplate', true);

            // •Óleo -> [ItemMpId: 444][KorId: 7]
            // •Filtro óleo -> [ItemMpId: 122][KorId: 7]
            // •Filtro ar -> [ItemMpId: 190][KorId: 7]
            // •Filtro combustível -> [ItemMpId: 389][KorId: 7]
            // •Filtro habitáculo -> [ItemMpId: 435][KorId: 7]
            // •Velas ignição -> [ItemMpId: 370][KorId: 7]

           let arrayClickedItems = this.clickedItems.map(item => Object.assign({itemMpId: item.id, korId: 7, qualColId: item.qualColId}));

            let body = {
                itemMpIdKorId: arrayClickedItems,
                kilometers: this.kilometers
            };

            return BudgetServicePostOperationsFromItemMpIdAndKorId(body)
                .then(response => {
                    this.$router.push({ name: 'budget-summary' });
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.$store.commit('loadings/setStateLoadingTemplate', false);

                    this.modal.iconColor = 'warning';
                    this.modal.iconName = 'mdi-alert-outline';
                    this.modal.message = this.$t('module-budget.simple-revision.modal-msg');
                    throw new Error('error to get operations - simple revision b2b', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                });
        },

        getSimpleRevisionOperations() {
            return BudgetServiceGetSimpleRevisionOperations()
                .then(response => {
                    this.checkBoxOperations = response.data.result;
                    let newItens = [];
                    for (let item in this.checkBoxOperations) {
                        if (this.checkBoxOperations[item].itemMpId === 444) {
                            Object.assign(this.checkBoxOperations[item], {
                                workPosDescription: this.checkBoxOperations[item].workPosText,
                                workPosCriteriaDescription: this.checkBoxOperations[item].workPosText,
                                singleWorkTime: this.checkBoxOperations[item].calculatedTime
                            });
                            newItens.push(this.checkBoxOperations[item]);
                        }
                        if (this.checkBoxOperations[item].itemMpId === 122) {
                            Object.assign(this.checkBoxOperations[item], {
                                workPosDescription: this.checkBoxOperations[item].workPosText,
                                workPosCriteriaDescription: this.checkBoxOperations[item].workPosText,
                                singleWorkTime: this.checkBoxOperations[item].calculatedTime
                            });
                            newItens.push(this.checkBoxOperations[item]);
                        }
                        if (this.checkBoxOperations[item].itemMpId === 190) {
                            Object.assign(this.checkBoxOperations[item], {
                                workPosDescription: this.checkBoxOperations[item].workPosText,
                                workPosCriteriaDescription: this.checkBoxOperations[item].workPosText,
                                singleWorkTime: this.checkBoxOperations[item].calculatedTime
                            });
                            newItens.push(this.checkBoxOperations[item]);
                        }
                        if (this.checkBoxOperations[item].itemMpId === 389) {
                            Object.assign(this.checkBoxOperations[item], {
                                workPosDescription: this.checkBoxOperations[item].workPosText,
                                workPosCriteriaDescription: this.checkBoxOperations[item].workPosText,
                                singleWorkTime: this.checkBoxOperations[item].calculatedTime
                            });
                            newItens.push(this.checkBoxOperations[item]);
                        }
                        if (this.checkBoxOperations[item].itemMpId === 435) {
                            Object.assign(this.checkBoxOperations[item], {
                                workPosDescription: this.checkBoxOperations[item].workPosText,
                                workPosCriteriaDescription: this.checkBoxOperations[item].workPosText,
                                singleWorkTime: this.checkBoxOperations[item].calculatedTime
                            });
                            newItens.push(this.checkBoxOperations[item]);
                        }
                        if (this.checkBoxOperations[item].itemMpId === 8426) {
                            Object.assign(this.checkBoxOperations[item], {
                                workPosDescription: this.checkBoxOperations[item].workPosText,
                                workPosCriteriaDescription: this.checkBoxOperations[item].workPosText,
                                singleWorkTime: this.checkBoxOperations[item].calculatedTime
                            });
                            newItens.push(this.checkBoxOperations[item]);
                        }
                    }
                    this.operationsToShow = newItens;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.catchMsg = true;
                    this.modal.iconColor = 'warning';
                    this.modal.iconName = 'mdi-alert-outline';
                    this.modal.message = this.$t('module-budget.simple-revision.modal-msg2');
                    throw new Error('error to get operations - simple revision b2b', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                });
        },

        storageBudgetStartedBy() {
            const getBudgetStartedBy = this.$store.getters['budget/getBudgetStartedBy'];
            if(!getBudgetStartedBy || !getBudgetStartedBy.budgetId) {
                const payload = {
                    budgetId: 2,
                    budgetName: 'simple-revision'
                }
                this.$store.commit('budget/setBudgetStartedBy', payload);
            }
        },
    },

    mounted() {
      this.getSimpleRevisionOperations();

      this.$refs.simple_revision_form.validate();
    }
};
</script>

<style lang="scss">
@import '@sass/_variables.scss';

.padding-div {
    padding: 1.5rem 1.5rem 0.5rem 1.5rem !important;
}
</style>
